export default function (element, asArray = false) {
  if (!element) {
    console.error('Cannot get $refs on undefined element: ', element)
    return null
  }

  const refs = element.querySelectorAll('[ref]')
  const result = {}

  refs.forEach((ref) => {
    const name = ref.getAttribute('ref')
    const search = result[name]

    if (search === undefined) {
      result[name] = ref
    } else if (Array.isArray(result[name])) {
      result[name].push(ref)
    } else {
      result[name] = [result[name], ref]
    }
  })

  return asArray && !Array.isArray(result) ? [result] : result
}
